/* Main head inline script, moved out of layout/theme.liquid <head> (CRO Step 4).
 * Runs with defer AFTER jquery.min.js/vendor.js and BEFORE theme.min.js.
 * select2 loads only on /cart (see layout/theme.liquid); aioo-perf-loader.js
 * provides aiooEnsureSelect2() for dynamic fallback.
 */
  document.addEventListener("DOMContentLoaded", function () {
    // Clean bad/empty model filter params from URL to avoid empty pages (no redirects)
    try {
      var urlObj = new URL(window.location.href);
      var params = urlObj.searchParams;
      var changed = false;
      ['filter.v.m.custom.compatible_model','filter.p.m.custom.compatible_model'].forEach(function(k){
        var v = params.get(k);
        if (v === '' || v === '?' ) { params.delete(k); changed = true; }
      });
      if (changed) {
        urlObj.search = params.toString();
        window.history.replaceState({}, '', urlObj.toString());
      }
    } catch(e) { /* no-op */ }
    const links = document.querySelectorAll('.mm6main a');
    const firstlink = links.length > 0 ? links[0] : null;
    const firstdiv = document.querySelector("#FirstCustom2Div");
    const divs = document.querySelectorAll('.admmsub');
    const maindivs = document.querySelectorAll(".mmfull");

    
  
    links.forEach((link, index) => {
      link.addEventListener('mouseover', function () {
        var self = this;
        requestAnimationFrame(function () {
          links.forEach(function (lnk) {
            lnk.classList.remove('active');
          });
          divs.forEach(function (div) {
            div.classList.remove('active');
          });
          self.classList.add('active');
          if (divs[index]) divs[index].classList.add('active');
        });
      }, { passive: true });
    });

    maindivs.forEach((maindiv) => {
      maindiv.addEventListener('mouseleave', function () {
        requestAnimationFrame(function () {
          const currentLinks = document.querySelectorAll('.mm6main a');
          currentLinks.forEach(link => {
            link.classList.remove('active');
          });
          if (firstlink) firstlink.classList.add('active');
        });
      }, { passive: true });
    });
  
  
  
  
    var urlParams = new URLSearchParams(window.location.search);
    // REMOVE auto-rewrite of facet prefix to prevent reload loops; only clean params below
    var isAiooParamTrue = urlParams.get('aioo') === 'true';
    var hasDiscountBeenApplied = document.cookie.split('; ').some((item) => item.trim().startsWith('discount_applied='));
  
    if (isAiooParamTrue && !hasDiscountBeenApplied) {
      // Show the popup only if the 'aioo' parameter is 'true' and the discount hasn't been applied before
      $.magnificPopup.open({
        items: {
          src: '#discount-popup'
        },
        type: 'inline',
        mainClass: 'mfp-zoom-in', // Set the class directly here
        removalDelay: 300 // Optional: Delay in milliseconds before popup is removed
      });
  
      // Set a cookie to indicate that the popup has been shown
      var expiryDate = new Date();
      expiryDate.setFullYear(expiryDate.getFullYear() + 1); // The cookie expires in 1 year
      document.cookie = `discount_applied=true; expires=${expiryDate.toUTCString()}; path=/`;
  
    }
    // Legacy model2/select2 and old device-selector handlers removed.
    // Active device model session is handled by assets/aioo-ux.js.
  
    const SlideElement1 = document.getElementById("Slide1");
    const SlideElement2 = document.getElementById("Slide2");
  
    const NotifBar = document.getElementById("NotifBar");
    const SectionCover = document.getElementById("SectionCover");
    const reviewStars = document.querySelectorAll(".review__stars svg");
    const SVG1 = document.getElementById("SVG1");
    const SVG2 = document.getElementById("SVG2");
    const SVG3 = document.getElementById("SVG3");
    const SVG4 = document.getElementById("SVG4");
    const gitems = document.querySelectorAll(".gitem.modded2");
    const brandItems = document.querySelectorAll(".details-mod");
    const detailsModButton = document.querySelectorAll('.details-mod button');
    const detailsMod2Text = document.querySelectorAll(".details-mod2 h3");
    const reviewText = document.getElementById("ReviewContent");
    const StoreFeaturesText = document.querySelectorAll(".store-info-mod .fl2 .tc");
    const secTitle = document.querySelectorAll(".sec-ttl h2");
  
    function applySlide1Styles() {
      // Remove Slide 2 styles
      // Redevice-legacy elements may be absent on the current homepage (e.g. #NotifBar);
      // an unguarded access here used to throw and kill the rest of this handler
      // (including the drawer parcel-terminal select2 init below).
      if (NotifBar) NotifBar.classList.remove('notifBar-slide2');
      if (SectionCover) SectionCover.classList.remove('slide2-bg');
      [SVG1, SVG2, SVG3, SVG4, ...reviewStars].filter(Boolean).forEach(star => star.classList.remove('slide2-svg'));
      gitems.forEach(item => {
        item.classList.remove('slide2-bg');
        item.classList.remove('slide2-text');
      });
      brandItems.forEach(item => {
        item.classList.remove("slide2-bg");
        item.classList.remove('slide2-text');
      });
      if (reviewText) reviewText.classList.remove("slide2-text");
      StoreFeaturesText.forEach(item => {
        item.classList.remove("slide2-text");
      });
      detailsMod2Text.forEach(item => {
        item.classList.remove("slide2-text");
      });
      detailsModButton.forEach(item => {
        item.classList.remove("btn1");
      });
      secTitle.forEach(item => {
        item.classList.remove("slide2-text");
      });
      // Apply Slide 1 styles
      if (NotifBar) NotifBar.classList.add('notifBar-slide1');
      if (SectionCover) SectionCover.classList.add('slide1-bg');
      [SVG1, SVG2, SVG3, SVG4, ...reviewStars].filter(Boolean).forEach(star => star.classList.add('slide1-svg'));
      gitems.forEach(item => {
        item.classList.add('slide1-bg');
        item.classList.add('slide1-text');
      });
      brandItems.forEach(item => {
        item.classList.add("slide1-bg");
        item.classList.add('slide1-text');
      });
      if (reviewText) reviewText.classList.add("slide1-text");
      StoreFeaturesText.forEach(item => {
        item.classList.add("slide1-text");
      });
      detailsMod2Text.forEach(item => {
        item.classList.add("slide1-text");
      });
      detailsModButton.forEach(item => {
        item.classList.add("btn2");
      });
      secTitle.forEach(item => {
        item.classList.add("slide1-text");
      });
    }

    function applySlide2Styles() {
      // Remove Slide 1 styles
      if (NotifBar) NotifBar.classList.remove('notifBar-slide1');
      if (SectionCover) SectionCover.classList.remove('slide1-bg');
      [SVG1, SVG2, SVG3, SVG4, ...reviewStars].filter(Boolean).forEach(star => star.classList.remove('slide1-svg'));
      gitems.forEach(item => {
        item.classList.remove('slide1-bg');
        item.classList.remove('slide1-text');
      });
      brandItems.forEach(item => {
        item.classList.remove("slide1-bg");
        item.classList.remove('slide1-text');
      });
      if (reviewText) reviewText.classList.remove("slide1-text");
      StoreFeaturesText.forEach(item => {
        item.classList.remove("slide1-text");
      });
      detailsMod2Text.forEach(item => {
        item.classList.remove("slide1-text");
      });
      detailsModButton.forEach(item => {
        item.classList.remove("btn2");
      });
      secTitle.forEach(item => {
        item.classList.remove("slide1-text");
      });
      // Apply Slide 2 styles
      if (NotifBar) NotifBar.classList.add('notifBar-slide2');
      if (SectionCover) SectionCover.classList.add('slide2-bg');
      [SVG1, SVG2, SVG3, SVG4, ...reviewStars].filter(Boolean).forEach(star => star.classList.add('slide2-svg'));
      gitems.forEach(item => {
        item.classList.add('slide2-bg');
        item.classList.add('slide2-text');
      });
      brandItems.forEach(item => {
        item.classList.add("slide2-bg");
        item.classList.add('slide2-text');
      });
      if (reviewText) reviewText.classList.add("slide2-text");
      StoreFeaturesText.forEach(item => {
        item.classList.add("slide2-text");
      });
      detailsMod2Text.forEach(item => {
        item.classList.add("slide2-text");
      });
      detailsModButton.forEach(item => {
        item.classList.add("btn1");
      });
      secTitle.forEach(item => {
        item.classList.add("slide2-text");
      });
    }
  
    function clearStyles() {
      // Clear styles from all elements
      if (NotifBar) NotifBar.className = '';
      if (SectionCover) SectionCover.className = '';
      reviewStars.forEach(star => star.className = '');
      gitems.forEach(item => item.className = 'gitem modded2');
    }
  
    function checkSelectedSlides() {
      //  clearStyles();
      if (SlideElement1 && SlideElement1.classList.contains('is-selected')) {
        applySlide1Styles();
      } else if (SlideElement2 && SlideElement2.classList.contains('is-selected')) {
        applySlide2Styles();
      } else {
        applySlide1Styles();
      }
    }
    const page = "/";
    if (window.location.pathname === page) {
      var runHomeSlideStyles = function () {
        checkSelectedSlides();
      };
      var idle = window.requestIdleCallback || function (cb) { setTimeout(cb, 1); };
      idle(runHomeSlideStyles);
    };
  

    const FilterToBar = document.getElementById("FilterBar");
    const FiltersBtn = document.getElementById("FiltersBtn");
    const ProdActionBtn = document.getElementById("ProdAction");
    const backToTopButton = document.querySelector('.back-to-top');
    const BuyMoreContainer = document.querySelector(".buymore__container");
  
    // Get the current template type from Shopify Liquid
    var currentTemplate = (window.AIOO_PAGE || {}).template || '';
    var currentProdType = (window.AIOO_PAGE || {}).productType || '';
    // Locale-independent: product.type is translated on /en and /ru.
    var currentPhoneKind = (window.AIOO_PAGE || {}).phoneKind || '';

    if (currentTemplate === "collection.accesories-collection") {
      if (NotifBar) {
        NotifBar.classList.add('notifBar-slide1');
      }
      if (FilterToBar) {
        FilterToBar.classList.add("acc");
      }
      if (FiltersBtn) {
        FiltersBtn.classList.add("acc");
      }
      if (backToTopButton) {
        backToTopButton.classList.add("acc");
      }
      if (BuyMoreContainer) {
        BuyMoreContainer.classList.add("acc");
      }
  
    } else if (currentTemplate === "product" && currentPhoneKind !== "used") {
      if (NotifBar) {
        NotifBar.classList.add('notifBar-slide1');
      }
      if (ProdActionBtn) {
        ProdActionBtn.classList.add("acc");
      }
      if (backToTopButton) {
        backToTopButton.classList.add("acc");
      }
      if (BuyMoreContainer) {
        BuyMoreContainer.classList.add("acc");
      }
    } else if (currentTemplate === "page.jobs") {
      if (backToTopButton) {
        backToTopButton.classList.add("acc");
      }
      if (BuyMoreContainer) {
        BuyMoreContainer.classList.add("hide");
      }
      if (NotifBar) {
        NotifBar.classList.add('notifBar-slide1');
      }
      if (SectionCover) {
        SectionCover.classList.add("slide1-bg")
      }
      if (secTitle && secTitle.forEach) {
        secTitle.forEach(item => {
          item.classList.add("slide1-text");
        });
      }
      if (StoreFeaturesText && StoreFeaturesText.forEach) {
        StoreFeaturesText.forEach(item => {
          item.classList.add("slide1-text");
        });
      }
    } else if (currentTemplate === "page.stores") {
      if (backToTopButton) {
        backToTopButton.classList.add("acc");
      }
      if (NotifBar) {
        NotifBar.classList.add('notifBar-slide1');
      }
      if (BuyMoreContainer) {
        BuyMoreContainer.classList.add("hide");
      }
    }
  
  
    if (window.location.pathname === "/collections/in-stock-iphones") {
      // Model quick-nav (.model-links / product__link fetch-and-build) and the
      // "Kopējais pieejamo konfigurāciju skaits" counter were removed 2026-07-21 —
      // replaced by the server-rendered collection-phone-model-nav.liquid widget.

      // АГРЕССИВНОЕ отключение бесконечного скроллинга для всех страниц
      $(document).ready(function() {
        // Отключаем все обработчики событий для бесконечного скроллинга
        $(window).off('scroll.infiniteScroll load.infiniteScroll delayed-resize.infiniteScroll');
        $(window).off('scroll load delayed-resize'); // Отключаем все связанные события
        $(document).off('click', '.infinitpagin a.loadMore'); // Отключаем клики на кнопки загрузки
        
        // Удаляем элементы бесконечного скроллинга
        $('.infinitpaginOuter, .infinitpagin, .loadMore, .infinite').remove();
        
        // Переопределяем функции бесконечного скроллинга глобально.
        // Do not replace theme.collectionView: that constructor binds the
        // sidebar checkbox handler which calls ajaxfilter. Stubbing it leaves
        // the grid skeleton up forever (Produkta veids / Krāsa / price).
        window.infiniteScroll = function() { return false; };
        window.loadMoreBtn = function() { return false; };
        window.loadMore = function() { return false; };

        if (typeof theme !== 'undefined') {
          theme.infiniteScroll = function() { return false; };
          theme.loadMoreBtn = function() { return false; };
          theme.loadMore = function() { return false; };
        }
        
        // One-time cleanup via MutationObserver — no polling loop
        new MutationObserver(function(mutations, obs) {
          $('.infinitpaginOuter, .infinitpagin, .loadMore, .infinite').remove();
          if (!$('.infinitpaginOuter, .infinitpagin, .loadMore, .infinite').length) obs.disconnect();
        }).observe(document.body || document.documentElement, { childList: true, subtree: true });
        
        // Block only pagination fetches. A blanket GET block (any request while
        // .infinitpagin exists) also swallowed filter AJAX and left an empty grid.
        var originalAjax = $.ajax;
        $.ajax = function(url, options) {
          var settings = typeof url === 'object' ? url : (options || {});
          var requestUrl = typeof url === 'string' ? url : (settings && settings.url);
          var type = (settings && settings.type) || 'GET';
          if (requestUrl && String(type).toUpperCase() === 'GET' && /[?&]page=/.test(String(requestUrl))) {
            return false;
          }
          return originalAjax.apply(this, arguments);
        };
        
      });

    } else if (window.location.pathname === "/cart") {
      var initCartParcelSelect2 = function () {
        var $parcel = $('#parcelTerminals');
        if ($parcel.length && !$parcel.hasClass('select2-hidden-accessible')) {
          $parcel.select2();
        }
      };
      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.select2) {
        initCartParcelSelect2();
      } else if (typeof window.aiooEnsureSelect2 === 'function') {
        window.aiooEnsureSelect2().then(initCartParcelSelect2).catch(function () { /* no-op */ });
      }

    } else { }

    // Auto-clean stale localStorage selections only when legacy model2 filter exists
    try {
      var mdlSel = document.getElementById('model2');
      function optionExists(val) {
        if (!mdlSel || !val) return false;
        var t = String(val).trim();
        for (var i = 0; i < mdlSel.options.length; i++) {
          if (String(mdlSel.options[i].text || mdlSel.options[i].value).trim() === t) return true;
        }
        return false;
      }
      if (mdlSel) {
        var lsModel = localStorage.getItem('AIOO_selectedModel');
        if (lsModel && !optionExists(lsModel)) {
          localStorage.removeItem('AIOO_selectedModel');
        }
        var lsDevice = localStorage.getItem('AIOO_selectedDevice');
        if (lsDevice && !optionExists(lsDevice)) {
          localStorage.removeItem('AIOO_selectedDevice');
        }
      }
    } catch(e) { /* no-op */ }


    $('.cardBtn').on('click', function() {
      var productId = $(this).data('product-id');
      $('.cardExpand[data-product-id="' + productId + '"]').slideToggle();
    });
  });
  
  
  const page = "/";
  if (window.location.pathname != page) {
    window.addEventListener('DOMContentLoaded', function () {
      $(document).ready(function () {
        
        $('#model').change(function () {
          // Get the selected value from the dropdown
          var selectedModel = $(this).val();
          

          // Uncheck all checkboxes in the filter form
          $('#CollectionFiltersForm .custCheck').prop('checked', false);

          // Check the checkbox that corresponds to the selected model
          $('#CollectionFiltersForm .custCheck').each(function () {
            if (this.value === selectedModel) {
              $(this).prop('checked', true);
            }
          });

          // Trigger the filter logic (assuming it's triggered by a checkbox change)
          $('#CollectionFiltersForm .custCheck').first().change();
        });
      });
    });
    function openExplanation(evt, Feature) {
      var i, FeatureRowContentExp, FeatureRowElement;
      FeatureRowContentExp = document.getElementsByClassName('FeatureRowContent-Exp');
      for (i = 0; i < FeatureRowContentExp.length; i++) {
        FeatureRowContentExp[i].style.display = 'none';
      }
  
      var active = evt.currentTarget.classList.contains('active');
  
      if (active) {
  
        document.getElementById(Feature).style.display = 'none';
        evt.currentTarget.classList.remove('active');
      } else {
  
        document.getElementById(Feature).style.display = 'block';
        evt.currentTarget.classList.add('active');
      }
    }
    function openFeatures(evt) {
      var i, FeatureRowWrapper, FeatureRowElement;
      FeatureRowWrapper = document.getElementsByClassName('FeatureRow-wrap');
      for (i = 0; i < FeatureRowWrapper.length; i++) {
        if (FeatureRowWrapper[i].style.display === 'none') {
          FeatureRowWrapper[i].style.display = 'block';
        } else {
          FeatureRowWrapper[i].style.display = 'none';
        }
      }
  
      evt.currentTarget.classList.toggle('active');
    }
  };
